module.exports = __webpack_public_path__ + "img/pale_white.7c6678a3.svg";